/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_ConnectInputs */

const cs_settings_calendar_connect = /** @type {(inputs: Settings_Calendar_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit`)
};

const en_settings_calendar_connect = /** @type {(inputs: Settings_Calendar_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Settings_Calendar_ConnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_connect = /** @type {((inputs?: Settings_Calendar_ConnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_ConnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_connect(inputs)
	return cs_settings_calendar_connect(inputs)
});